var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktopFondoGracias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1587,
    height: 890,
    viewBox: "0 0 1587 890",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1587,
    height: 890,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-666.686 -1426.331)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 40.852,
    transform: "translate(1082.686 1737.089)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 40.852,
    transform: "translate(1103.112 1716.663)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 27.82,
    y2: 29.915,
    transform: "translate(1089.202 1722.132)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 27.82,
    x2: 29.915,
    transform: "translate(1088.154 1723.179)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.314 -1510.966)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 68.302,
    transform: "translate(1082.686 1750.814)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 68.302,
    transform: "translate(1116.837 1716.663)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 46.514,
    y2: 50.017,
    transform: "translate(1093.58 1725.806)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 46.514,
    x2: 50.017,
    transform: "translate(1091.829 1727.557)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.921, 0.391, -0.391, 0.921, -154.941, -1217.025)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 120.176,
    transform: "translate(1082.686 1776.751)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 120.176,
    transform: "translate(1142.774 1716.663)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x2: 81.84,
    y2: 88.003,
    transform: "translate(1101.854 1732.75)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    y1: 81.84,
    x2: 88.003,
    transform: "translate(1098.772 1735.831)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.314 -1027.177)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 33.513,
    transform: "translate(1082.686 1733.42)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 33.513,
    transform: "translate(1099.443 1716.663)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 22.823,
    y2: 24.541,
    transform: "translate(1088.031 1721.149)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 22.823,
    x2: 24.541,
    transform: "translate(1087.172 1722.009)",
    fill: "none",
    stroke: "#efde31",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-516.686 -1088.43)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.314 -1319.936)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 0.271,
    transform: "translate(1082.686 1716.799)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.271,
    transform: "translate(1082.822 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.185,
    y2: 0.199,
    transform: "translate(1082.729 1716.7)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.185,
    x2: 0.199,
    transform: "translate(1082.722 1716.707)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-142.686 -911.936)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 0.271,
    transform: "translate(1082.686 1716.799)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.271,
    transform: "translate(1082.822 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.185,
    y2: 0.199,
    transform: "translate(1082.729 1716.7)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.185,
    x2: 0.199,
    transform: "translate(1082.722 1716.707)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-71.686 -1700.936)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 0.271,
    transform: "translate(1082.686 1716.799)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.271,
    transform: "translate(1082.822 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 0.185,
    y2: 0.199,
    transform: "translate(1082.729 1716.7)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 0.185,
    x2: 0.199,
    transform: "translate(1082.722 1716.707)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-629.643 -1593.283)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#e4e2db",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(441.357 -1683.283)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1032.643 -1340.283)",
    opacity: 0.579
  }, /*#__PURE__*/React.createElement("line", {
    x2: 7.62,
    transform: "translate(1082.686 1720.473)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 7.62,
    transform: "translate(1086.496 1716.663)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x2: 5.189,
    y2: 5.58,
    transform: "translate(1083.901 1717.683)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y1: 5.189,
    x2: 5.58,
    transform: "translate(1083.706 1717.879)",
    fill: "none",
    stroke: "#20201d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1188.665 -2285.709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1024.349,2715.038c45.174,5.875,84.731,35.7,92.3,81.372,5.444,32.85-1.316,51.657-13.492,66.174-18.69,22.283-50.555,33.529-67.979,70.835-28.47,60.95,69.079,122.089,105.906,51.436",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1247.771,2684.5c15.8-56.856,77.033-121.805,136.175-90.737s83.682,89.048,79.151,147.405-47.127,115.211-97.273,86.023c-22.75-13.244-22.625-49.227-6.2-69.8a124.874,124.874,0,0,1,95.786-43.414",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.825,2812.768a116.219,116.219,0,0,0,7.458,14.076c53.49,89.129-14,188.225-125.294,142.047-99.115-41.125-16.713-182.187,71.029-172.366,147.175,5.566,203.371,209.239,107.03,308.4",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.84,2985.471c65.147-97.329,73.559-283.824-50.407-335.793-86.8-25.537-153.885,59.987-138.378,138.533",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.178,2814.6",
    fill: "none",
    stroke: "#eddb45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopFondoGracias);
export default __webpack_public_path__ + "static/media/desktop_fondo_gracias.16457ab9d4e2e38923bda2f70523d2f5.svg";
export { ForwardRef as ReactComponent };